"use client"

import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

/**
 * Renders children into the `#page-bottom-slot` div that LayoutWrapper places
 * AFTER the site footer — the last thing on the page.
 *
 * Pages are server components and the footer lives in the client LayoutWrapper,
 * so there's no server-side way to compose past it. Nothing renders until the
 * slot is found on mount: rendering in place first would put the content next
 * to the page body (in the server HTML and until hydration), which is exactly
 * where page-bottom fine print such as photo credits must never appear. The
 * mount-then-portal order also keeps server and first client render identical,
 * so there is no hydration mismatch. Routes without the slot render nothing.
 */
export function PageBottomPortal({ children }: { children: React.ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setSlot(document.getElementById("page-bottom-slot"))
  }, [])

  if (!slot) return null
  return createPortal(children, slot)
}
